import styled from 'styled-components';
// import { MdHome, MdEvent, MdSupervisorAccount } from 'react-icons/md';

export const BackContainer = styled.div`
    width: 100%;
    height: 100%;
    background-color: rgba(255, 255, 255, 21%);
    justify-content: center;
    align-items: center;
    display: ${ props => props.visibilidade ? 'flex' : 'none' };
    position: fixed;
    top: 0;
    left: 0;
    z-index: 20;
    backdrop-filter: blur(7px) saturate(180%);
`;

export const ModalContainer = styled.div`
    /* max-height: calc(100vh - 200px); */
    max-width: calc(100vw - 70px);
    overflow-y: hidden;
    background-color: var(--cardBackgroundColor);
    box-shadow: 0px 0px 10px -3px rgba(0,0,0,0.75);
    border-radius: 10px;
    padding: 10px;
    position:relative;

`;

export const ContainerHeader = styled.div`
    display: flex;
    flex-direction: row;
    justify-content:center;
    align-items: center;
    padding:10px 0 20px 0px;
    border-bottom:1px solid #cecece;
    margin-bottom: 10px;

`;
export const ContainerClose = styled.div`
    position: absolute;
    right: 20px;
    top: 18px;
    font-size: 20px;
    display: flex;
    justify-content: center;
    justify-items: center;
    padding: 5px;
    border-radius: 50%;
    background: var(--backgroundColorHover);
    cursor:pointer;

    :hover{
        background-color: #cccccc;
    }
`;
